import OfficeEnvironment from '../../../base/OfficeEnvironment';
var ExcelFeature = function (_a) {
    var children = _a.children;
    console.log('OfficeEnvironment.applicationType', OfficeEnvironment.applicationType);
    if (OfficeEnvironment.applicationType !== 'excel') {
        return null;
    }
    return children;
};
export default ExcelFeature;
//# sourceMappingURL=ExcelFeature.js.map